import { render, staticRenderFns } from "./XSJLPage.vue?vue&type=template&id=2a4b1335&scoped=true"
import script from "./XSJLPage.vue?vue&type=script&lang=js"
export * from "./XSJLPage.vue?vue&type=script&lang=js"
import style0 from "./XSJLPage.vue?vue&type=style&index=0&id=2a4b1335&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b1335",
  null
  
)

export default component.exports